import { render } from "preact";
import type { ModalConfig } from "../shared/types.js";
import { isDesktop } from "../shared/detect.js";
import { trackImpression } from "../shared/tracking.js";
import { MobileLink } from "../shared/mobile-link.js";
import { TriggerButton } from "./trigger-button.js";
import { openModal } from "./modal.js";
import css from "../styles/tailwind.css?inline";

export function renderTrigger(hostEl: HTMLElement, config: ModalConfig): void {
  if (config.trigger.width === "full") {
    hostEl.style.display = "block";
    hostEl.style.width = "100%";
  }

  let shadow = hostEl.shadowRoot;
  if (shadow) {
    shadow.innerHTML = "";
  } else {
    shadow = hostEl.attachShadow({ mode: "open" });
  }

  const style = document.createElement("style");
  style.textContent = css;
  shadow.appendChild(style);

  const root = document.createElement("div");
  root.style.fontFamily = "system-ui, -apple-system, sans-serif";
  shadow.appendChild(root);

  const component = isDesktop()
    ? <TriggerButton
        config={config.trigger}
        logoUrl={config.logoUrl}
        onClick={() => openModal(config, hostEl)}
      />
    : <MobileLink
        newTab={config.mobileNewTab ?? false}
        config={{
          ...config.trigger,
          shareUrl: config.shareUrl,
          embedApiUrl: config.embedApiUrl,
          formId: config.formId,
          embed: config.embed,
          attribution: config.attribution,
          logoUrl: config.logoUrl,
          preview: config.preview,
        }}
      />;

  render(component, root);

  (hostEl as any).__fvUnmount = () => render(null, root);
  if (!config.preview) {
    trackImpression(config.embedApiUrl, config.formId, config.embed, config.attribution, hostEl);
  }
}
